export enum OperationTypeEnum{
    INTERNAL='INTERNAL',
    EXTERNAL='EXTERNAL',
}